import { render, staticRenderFns } from "./BaseLottieAnimation.vue?vue&type=template&id=450de7f7&"
import script from "./BaseLottieAnimation.vue?vue&type=script&lang=js&"
export * from "./BaseLottieAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports